import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type { PreparationTimeHourlyReport, PreparationTimeHourlyRequestData } from "../../../../graphql/types"
import { PreparationTimeByItemReport, PreparationTimeByItemRequestData } from "../../../../graphql/types"

export const fetchPreparationTimeByItemReport = (
    headers: Record<string, any>,
    data: PreparationTimeByItemRequestData
): Promise<PreparationTimeByItemReport> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query preparationTimeByItemReport($data: PreparationTimeByItemRequestData!) {
                  preparationTimeByItemReport(data: $data) {
                    items {
                      productId,
                      name,
                      count,
                      preparationTime {
                        average,
                        min,
                        max,
                        p50,
                        p75,
                        p90,
                      }
                    }
                  }
                }    
            `,
            operationName: "preparationTimeByItemReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response != null && response.data != null && response.data.preparationTimeByItemReport != null) {
            return response.data.preparationTimeByItemReport
        }

        return {
            items: [],
        }
    })

export const fetchPreparationTimeHourlyReport = (
    headers: Record<string, any>,
    data: PreparationTimeHourlyRequestData
): Promise<PreparationTimeHourlyReport> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query preparationTimeHourlyReport($data: PreparationTimeHourlyRequestData!) {
                  preparationTimeHourlyReport(data: $data) {
                    hours {
                      index,
                      hour,
                      count,
                      itemNames,
                      preparationTime {
                        average,
                        min,
                        max,
                        p50,
                        p75,
                        p90,
                      }
                    }
                  }
                }    
            `,
            operationName: "preparationTimeHourlyReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response != null && response.data != null && response.data.preparationTimeHourlyReport != null) {
            return response.data.preparationTimeHourlyReport
        }

        return {
            hours: [],
        }
    })
